export default {
  id: null,
  dataInicial: null,
  diaSemana: null,
  horaInicial: null,
  horaFinal: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/horarioAtendimentomodel.js